import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SimpleCollapse from './SimpleCollapse';
import ClientProvider from './client';
export default createDemo(import.meta.url, SimpleCollapse, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/transitions/demos/simple-collapse/SimpleCollapse.tsx",
    "fileName": "SimpleCollapse.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\nimport Paper from '@mui/material/Paper';\nimport Collapse from '@mui/material/Collapse';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst icon = (\n  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>\n    <svg width=\"100\" height=\"100\">\n      <Box\n        component=\"polygon\"\n        points=\"0,100 50,00, 100,100\"\n        sx={(theme) => ({\n          fill: theme.palette.common.white,\n          stroke: theme.palette.divider,\n          strokeWidth: 1,\n        })}\n      />\n    </svg>\n  </Paper>\n);\n\nexport default function SimpleCollapse() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [checked, setChecked] = React.useState(false);\n\n  const handleChange = () => {\n    setChecked((prev) => !prev);\n  };\n\n  return (\n    <Box sx={{ height: 300 }}>\n      <FormControlLabel\n        control={<Switch checked={checked} onChange={handleChange} />}\n        label=\"Show\"\n      />\n      <Box\n        sx={{\n          '& > :not(style)': {\n            display: 'flex',\n            justifyContent: 'space-around',\n            height: 120,\n            width: 250,\n          },\n        }}\n      >\n        <div>\n          <Collapse in={checked}>{icon}</Collapse>\n          <Collapse in={checked} collapsedSize={40}>\n            {icon}\n          </Collapse>\n        </div>\n        <div>\n          <Box sx={{ width: '50%' }}>\n            <Collapse orientation=\"horizontal\" in={checked}>\n              {icon}\n            </Collapse>\n          </Box>\n          <Box sx={{ width: '50%' }}>\n            <Collapse orientation=\"horizontal\" in={checked} collapsedSize={40}>\n              {icon}\n            </Collapse>\n          </Box>\n        </div>\n      </Box>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 68,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\nimport Paper from '@mui/material/Paper';\nimport Collapse from '@mui/material/Collapse';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst icon = (\n  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>\n    <svg width=\"100\" height=\"100\">\n      <Box\n        component=\"polygon\"\n        points=\"0,100 50,00, 100,100\"\n        sx={(theme) => ({\n          fill: theme.palette.common.white,\n          stroke: theme.palette.divider,\n          strokeWidth: 1,\n        })}\n      />\n    </svg>\n  </Paper>\n);\n\nexport default function SimpleCollapse() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [checked, setChecked] = React.useState(false);\n\n  const handleChange = () => {\n    setChecked((prev) => !prev);\n  };\n\n  return (\n    <Box sx={{ height: 300 }}>\n      <FormControlLabel\n        control={<Switch checked={checked} onChange={handleChange} />}\n        label=\"Show\"\n      />\n      <Box\n        sx={{\n          '& > :not(style)': {\n            display: 'flex',\n            justifyContent: 'space-around',\n            height: 120,\n            width: 250,\n          },\n        }}\n      >\n        <div>\n          <Collapse in={checked}>{icon}</Collapse>\n          <Collapse in={checked} collapsedSize={40}>\n            {icon}\n          </Collapse>\n        </div>\n        <div>\n          <Box sx={{ width: '50%' }}>\n            <Collapse orientation=\"horizontal\" in={checked}>\n              {icon}\n            </Collapse>\n          </Box>\n          <Box sx={{ width: '50%' }}>\n            <Collapse orientation=\"horizontal\" in={checked} collapsedSize={40}>\n              {icon}\n            </Collapse>\n          </Box>\n        </div>\n      </Box>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 68,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Switch",
      "@mui/material/Paper",
      "@mui/material/Collapse",
      "@mui/material/FormControlLabel"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
